export default __webpack_public_path__ + "newlogo_sm.png";